import { ValidatorFn, AbstractControl } from "@angular/forms";
import moment from "moment";

export function minDate(min: string): ValidatorFn {
  return (control: AbstractControl): Record<string, boolean> | null => {
    if (moment(control.value).diff(min, "days") < 0) {
      return { minDate: true };
    }
    return null;
  };
}
